export default __webpack_public_path__ + "static/media/story-SLIDE_5.ca6b1604.jpg";